/**
 * en-GB messages for the Phase 4 contract (architect): module names, permissions, triggers, webhook events, API scopes,
 * merge fields, core settings added in Phase 4 and shared message keys. Builders add their own screen text in their
 * task's file.
 */
export const archEnGB = {
    // Modules
    'module.billing': 'Billing',
    'module.wallet': 'Wallet passes',
    'module.onboarding': 'Getting started',
    // Permission groups and permissions
    'permGroup.billing': 'Billing',
    'permGroup.wallet': 'Wallet passes',
    'perm.data_protection.view': 'View data requests, retention and the data protection report',
    'perm.data_protection.requests': 'Manage data requests (approve, refuse, complete)',
    'perm.data_protection.legal_hold': 'Place and release legal holds',
    'perm.billing.view': 'View plan, usage and invoices',
    'perm.billing.manage': 'Manage the billing contact and payment method',
    'perm.wallet.manage': 'Manage wallet pass settings',
    'perm.id_checks.manage': 'Manage ID check settings and confirm the data protection impact assessment',
    'perm.platform.billing_view': 'View plans, subscriptions and invoices for every organisation',
    'perm.platform.billing_manage': 'Manage plans, subscriptions, invoices, credit notes and payments',
    // Usage metrics
    'usage.sites': 'Sites',
    'usage.ai_questions': 'AI questions',
    // Notification triggers
    'notify.trigger.data_request.received': 'Data request received',
    'notify.trigger.data_request.due_soon': 'Data request deadline is near',
    'notify.trigger.id_check.failed': 'ID check failed',
    // Notification channels and recipients
    'notify.channel.slack': 'Slack',
    'notify.channel.teams': 'Microsoft Teams',
    'notify.recipient.connection': 'A Slack or Teams channel',
    // Webhook events
    'whk.event.person.erased': "A person's data was erased",
    // API scopes
    'apiScope.sites.read': 'Read sites',
    'apiScope.groups.read': 'Read groups',
    'apiScope.members.read': 'Read members',
    'apiScope.members.write': 'Add, change and archive members',
    'apiScope.visits.read': 'Read visit history',
    'apiScope.preregistrations.read': 'Read expected visitors',
    'apiScope.preregistrations.write': 'Add, change and cancel expected visitors',
    // Merge fields
    'merge.wallet.link': 'Add to Google Wallet link',
    'merge.request.reference': 'Request reference',
    'merge.request.kind': 'Request type',
    'merge.request.due_date': 'Request deadline',
    'merge.request.days_left': 'Days left',
    // Core tenant settings added in Phase 4 (security card)
    'settings.core.security.passwordExpiryDays': 'Passwords expire after this many days (0 = never)',
    'settings.core.security.passwordReuseCount': 'Refuse the last this many passwords (0 = no check)',
    'settings.core.security.reauthHours': 'Ask everyone to sign in again after this many hours (0 = platform default)',
    'settings.core.security.supportNotifyAdmins': 'Email administrators when support signs in',
    // Core platform settings added in Phase 4
    'settings.core.entra': 'Microsoft Entra app (sign-in and directory sync)',
    'settings.core.entra.clientId': 'Application (client) ID',
    'settings.core.entra.clientSecretEnc': 'Client secret',
    'settings.core.entra.requireVerifiedEmailClaim': 'Require Microsoft to confirm the email domain (xms_edov)',
    'settings.core.support': 'Support access',
    'settings.core.support.maxMinutes': 'Longest support session in minutes (0 = support access off)',
    'settings.core.domains': 'Custom domains',
    'settings.core.domains.baseDomain': 'Base domain for free subdomains',
    'settings.core.domains.cnameTarget': 'Address customers point their domain at',
    'settings.core.domains.maxPerTenant': 'Custom domains per organisation (0 = off)',
    'settings.core.tenantClosure': 'Closing an organisation',
    'settings.core.tenantClosure.noticeDays': 'Days between the closure request and deletion',
    'settings.core.tenantClosure.exportLinkDays': 'Days the final export can be downloaded',
    // Shared message keys
    'error.tenant_read_only': 'This account is on hold for an unpaid invoice, so changes are switched off. Please contact your administrator.',
    'auth.stage.password_change': 'Your password has expired. Please choose a new one.',
    'dp.your_data': 'Your data',
    'dp.your_data_footer': 'Your data: see, correct or remove what {sender} holds about you',
    'dp.keep.evacuation_law': 'Evacuation records are kept, without the name, as fire safety records.',
    'dp.keep.permit_law': 'Permit records are kept, without the name, as health and safety records.',
    'dp.keep.legal_hold': 'Kept because of a legal hold.',
    'dp.keep.agreement_chain': 'A placeholder stays so the signed agreement chain still verifies.',
};
//# sourceMappingURL=arch.js.map